import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { queryClient } from "Utilities/ReactQuery/queryClient";
import appendToFormData from "Utilities/appendToFormData";
import { fnThrowError } from "Utilities/fnReportError";

import householdProfileKeys from "./keys";

const getHouseholdDetail = async ({ userID }) => {
  const endpoint = `/user/householdDetail/${userID}`;
  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  const {
    householdProfile: { members },
  } = response;
  const memberIDs = members.map(({ userID: id }) => id);

  memberIDs.forEach((memberID) => {
    const queryKey = householdProfileKeys.householdDetail(memberID);
    queryClient.setQueryData(queryKey, response);
  });

  return response;
};

const setPrimaryNetwork = async ({ householdID, networkID }) => {
  const endpoint = `/households/setPrimaryNetwork`;
  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction
    .post(endpoint, { householdID, networkID })
    .catch((err) => {
      fnThrowError({
        message: `Error at ${endpoint}: ${err}`,
      });
    });

  return response;
};

const setHeadOfHousehold = async ({ userID, newStatusBool }) => {
  const endpoint = `/user/${userID}/updatePriv`;
  const formData = new FormData();
  appendToFormData(formData, { priv: "headOfHousehold", on: newStatusBool });

  const fetchFunction = new FnrFetch3(endpoint, formData);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const setHouseholdName = async ({ userID, name }) => {
  const endpoint = `/people/${userID}/updateHouseholdName`;
  const formData = new FormData();
  appendToFormData(formData, { name });

  const fetchFunction = new FnrFetch3(endpoint, formData);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const removeFromHousehold = async ({ userID }) => {
  const endpoint = `/people/${userID}/removeMemberFromHousehold`;
  const formData = new FormData();
  appendToFormData(formData, { userToRemoveID: userID });

  const fetchFunction = new FnrFetch3(endpoint, formData);
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

const getHouseholdDataByUserID = async (userID) => {
  const endpoint = `/family/getHouseholdDataForProfile`;

  const fetchFunction = new FnrFetch3(endpoint, { userID });
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export {
  getHouseholdDetail,
  setPrimaryNetwork,
  setHeadOfHousehold,
  removeFromHousehold,
  getHouseholdDataByUserID,
  setHouseholdName,
};
